import { render, staticRenderFns } from "./WeightsTable.vue?vue&type=template&id=3d80e3f5"
import script from "./WeightsTable.vue?vue&type=script&lang=js"
export * from "./WeightsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports